import { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import svgPaths from "../../../assets/new_ui_imports/Home/svg-tl21z7gm4q.js";
import imgDemoBadge from "../../../assets/new_ui_img/demo.svg";

// ─── Logo ─────────────────────────────────────────────────────────────────────
function GeoLogo({ dark = false }) {
  return (
    <svg width="198" height="39" viewBox="0 0 198 39" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="GeoParking Technologies">
      <g clipPath="url(#clip0_logo)">
        <path d={svgPaths.p1549ab20} fill="#43D651" />
        <path d={svgPaths.p35478f40} fill="#43D651" />
        <path d={svgPaths.p2b031f00} fill="#43D651" />
        <path d={svgPaths.p1d132100} fill="#009BE1" />
        <path d={svgPaths.p17495600} fill="#009BE1" />
        <path d={svgPaths.p1ad7cc80} fill="#009BE1" />
        <path d={svgPaths.p316215f0} fill="#009BE1" />
        <path d={svgPaths.p3349c200} fill="#009BE1" />
        <path d={svgPaths.p28021080} fill="#009BE1" />
        <path d={svgPaths.p3627b690} fill="#009BE1" />
        <path d={svgPaths.p3f6bcd00} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.pc5e0d20} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p32506200} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p1f2c4b00} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p268c0200} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.pbd5c880} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p2625ae80} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p38586a00} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p25325700} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p89c7ec0} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p3f52da00} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.pf9d8d00} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p22d44300} fill="url(#paint0_logo)" />
        <path d={svgPaths.p81ad600} fill="#F46FF0" />
        <path d={svgPaths.p81ad600} fill="url(#paint1_logo)" />
        <path d={svgPaths.p7c13680} fill="url(#paint2_logo)" />
        <path d={svgPaths.p2f9b4eb0} fill="url(#paint3_logo)" />
        <path d={svgPaths.p7051cc0} fill="white" />
        <path d={svgPaths.p2a7001f0} fill="white" />
        <path d={svgPaths.pd3fd400} fill="white" />
        <path d={svgPaths.p5de4a00} fill="white" />
        <path d={svgPaths.p1adebf00} fill="url(#paint4_logo)" />
        <path d={svgPaths.p1f12b500} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p1d1fb600} fill={dark ? "white" : "#565656"} />
        <path d={svgPaths.p3a326d80} fill={dark ? "white" : "#565656"} />
      </g>
      <defs>
        <linearGradient id="paint0_logo" x1="19.39" x2="19.39" y1="0" y2="37.54" gradientUnits="userSpaceOnUse">
          <stop stopColor="#9DBACF" /><stop offset="0.25" stopColor="white" /><stop offset="0.52" stopColor="#B3CBD7" />
          <stop offset="0.71" stopColor="#5A6585" /><stop offset="0.85" stopColor="#B3C4D4" /><stop offset="1" stopColor="#466C81" />
        </linearGradient>
        <linearGradient id="paint1_logo" x1="37.38" x2="1.46" y1="19.51" y2="19.51" gradientUnits="userSpaceOnUse">
          <stop stopColor="#014FA4" /><stop offset="1" stopColor="#029BE1" />
        </linearGradient>
        <linearGradient id="paint2_logo" x1="19.03" x2="19.61" y1="43.13" y2="5.51" gradientUnits="userSpaceOnUse">
          <stop stopColor="#014FA4" /><stop offset="1" stopColor="#029BE1" />
        </linearGradient>
        <radialGradient id="paint3_logo" cx="0" cy="0" r="1" gradientTransform="translate(19.68 24.29) scale(11.77 11.77)" gradientUnits="userSpaceOnUse">
          <stop stopColor="#014FA4" /><stop offset="1" stopColor="#029BE1" />
        </radialGradient>
        <linearGradient id="paint4_logo" x1="19.39" x2="19.39" y1="22.27" y2="3.52" gradientUnits="userSpaceOnUse">
          <stop stopColor="#014FA4" stopOpacity="0" /><stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_logo"><rect width="198" height="39" fill="white" /></clipPath>
      </defs>
    </svg>
  );
}

const envname = process.env.REACT_APP_ENV_TXT || null;
const isDemo = envname === "DEMO" || envname === "Engineering";

function useBasePath() {
  const location = useLocation();
  if (location.pathname.startsWith("/newDasboard")) return "/newDasboard";
  if (location.pathname.startsWith("/newDashboard")) return "/newDashboard";
  if (location.pathname.startsWith("/new")) return "/new";
  return "/newDashboard";
}

// ─── Header ───────────────────────────────────────────────────────────────────
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [companyOpen, setCompanyOpen] = useState(false);
  const [mobileCompanyOpen, setMobileCompanyOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();
  const basePath = useBasePath();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); setCompanyOpen(false); }, [location.pathname]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setCompanyOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const simpleLinks = [
    { label: "Home",       to: `${basePath}/home` },
    { label: "Solutions",  to: `${basePath}/solutions` },
    { label: "Technology", to: `${basePath}/technology` },
  ];

  const companyLinks = [
    { label: "Contact Us",          to: `${basePath}/contact` },
    { label: "Investor Relations",  to: `${basePath}/company` },
  ];

  const isActive = (to) => {
    if (to.endsWith("/home")) {
      return (
        location.pathname === basePath ||
        location.pathname === `${basePath}/` ||
        location.pathname.toLowerCase() === `${basePath}/home`.toLowerCase()
      );
    }
    return location.pathname.startsWith(to);
  };

  const isCompanyActive = companyLinks.some(({ to }) => location.pathname.startsWith(to));

  const navLinkClass = (active) =>
    `font-['Google_Sans_Flex',sans-serif] text-[16px] leading-tight transition-colors ${active ? "text-[#0a66c2] font-semibold" : "text-[#3f3f3f] hover:text-[#0a66c2]"}`;

  return (
    <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${scrolled ? "bg-white/95 backdrop-blur-sm shadow-[0_4px_10px_rgba(0,0,0,0.08)]" : "bg-white shadow-[0_4px_10px_rgba(0,0,0,0.08)]"}`}>
      <div className="max-w-[1400px] mx-auto px-6 h-20 flex items-center justify-between">
        <NavLink to={`${basePath}/home`} className="flex-shrink-0 flex items-center gap-2.5">
          <GeoLogo />
          {isDemo && (
            <img src={imgDemoBadge} alt="DEMO" className="h-[22px] w-auto inline-block select-none" />
          )}
        </NavLink>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8 lg:gap-10">
          {simpleLinks.map(({ label, to }) => (
            <NavLink
              key={label}
              to={to}
              className={navLinkClass(isActive(to))}
              style={{ fontVariationSettings: '"GRAD" 0, "ROND" 0, "wdth" 100' }}
            >
              {label}
            </NavLink>
          ))}

          {/* Company dropdown */}
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setCompanyOpen((prev) => !prev)}
              className={`flex items-center gap-1.5 ${navLinkClass(isCompanyActive)}`}
              style={{ fontVariationSettings: '"GRAD" 0, "ROND" 0, "wdth" 100' }}
              aria-expanded={companyOpen}
            >
              Company
              <svg
                className={`w-4 h-4 transition-transform duration-200 ${companyOpen ? "rotate-180" : ""}`}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {companyOpen && (
              <div className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-100 py-1.5 z-50 animate-in fade-in slide-in-from-top-1 duration-150">
                {companyLinks.map(({ label, to }) => (
                  <NavLink
                    key={label}
                    to={to}
                    onClick={() => setCompanyOpen(false)}
                    className={({ isActive: a }) =>
                      `block px-4 py-2 font-['Google_Sans_Flex',sans-serif] text-[15px] transition-colors ${a ? "text-[#0a66c2] bg-blue-50 font-semibold" : "text-[#3f3f3f] hover:bg-gray-50 hover:text-[#0a66c2]"}`
                    }
                    style={{ fontVariationSettings: '"GRAD" 0, "ROND" 0, "wdth" 100' }}
                  >
                    {label}
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        </nav>

        {/* CTA buttons */}
        <div className="hidden md:flex items-center gap-3">
          <NavLink to="/login" className="bg-[#0a66c2] text-white font-['Lato:Medium',sans-serif] text-[16px] px-5 py-2 rounded-[5px] hover:bg-[#0856a8] transition-colors">
            Login
          </NavLink>
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setMenuOpen((prev) => !prev)}
          className="md:hidden p-2 text-gray-700 hover:text-gray-900 focus:outline-none"
          aria-label="Toggle menu"
        >
          {menuOpen ? (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile drawer */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4 shadow-lg">
          {simpleLinks.map(({ label, to }) => (
            <NavLink
              key={label}
              to={to}
              onClick={() => setMenuOpen(false)}
              className={navLinkClass(isActive(to))}
              style={{ fontVariationSettings: '"GRAD" 0, "ROND" 0, "wdth" 100' }}
            >
              {label}
            </NavLink>
          ))}

          {/* Mobile company accordion */}
          <div>
            <button
              onClick={() => setMobileCompanyOpen((p) => !p)}
              className={`flex items-center justify-between w-full ${navLinkClass(isCompanyActive)}`}
              style={{ fontVariationSettings: '"GRAD" 0, "ROND" 0, "wdth" 100' }}
            >
              <span>Company</span>
              <svg
                className={`w-4 h-4 transition-transform duration-200 ${mobileCompanyOpen ? "rotate-180" : ""}`}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {mobileCompanyOpen && (
              <div className="pl-4 mt-2 flex flex-col gap-2 border-l-2 border-blue-100">
                {companyLinks.map(({ label, to }) => (
                  <NavLink
                    key={label}
                    to={to}
                    onClick={() => setMenuOpen(false)}
                    className={({ isActive: a }) =>
                      `font-['Google_Sans_Flex',sans-serif] text-[15px] py-1 ${a ? "text-[#0a66c2] font-semibold" : "text-[#555] hover:text-[#0a66c2]"}`
                    }
                    style={{ fontVariationSettings: '"GRAD" 0, "ROND" 0, "wdth" 100' }}
                  >
                    {label}
                  </NavLink>
                ))}
              </div>
            )}
          </div>

          <div className="pt-2 border-t border-gray-100 flex flex-col gap-2">
            <NavLink to="/login" className="bg-[#0a66c2] text-white font-['Lato:Medium',sans-serif] text-[16px] px-5 py-2 rounded-[5px] w-fit text-center">
              Login
            </NavLink>
          </div>
        </div>
      )}
    </header>
  );
}

// ─── Footer ───────────────────────────────────────────────────────────────────
export function Footer() {
  const basePath = useBasePath();

  const socialLinks = [
    {
      label: "LinkedIn",
      url: "https://www.linkedin.com/company/geoparking/",
      icon: (
        <svg className="w-6 h-6 text-[#0a66c2]" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
        </svg>
      ),
    },
    {
      label: "Twitter / X",
      url: "https://x.com/geoparking",
      icon: (
        <svg className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 23.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      ),
    },
    {
      label: "YouTube",
      url: "https://www.youtube.com/@geoparking",
      icon: (
        <svg className="w-6 h-6 text-[#ff0000]" viewBox="0 0 24 24" fill="currentColor">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
        </svg>
      ),
    },
  ];

  return (
    <footer className="bg-[#1a2332] text-white pt-14 pb-8">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 pb-12">
          <div className="md:col-span-2 flex flex-col gap-6">
            <NavLink to={`${basePath}/home`} className="inline-block">
              <GeoLogo dark />
            </NavLink>
            <div className="max-w-[480px]">
              <p className="font-['Lato:Regular',sans-serif] text-[#8399b9] text-[1.1rem] leading-[1.3]">
                GeoParking connects property owners with Robotaxi operators through an AI-powered platform that simplifies parking management, maximizes efficiency, and unlocks new revenue opportunities.
              </p>
            </div>
            <div className="flex items-center gap-4">
              {socialLinks.map((s) => (
                <a key={s.label} href={s.url} target="_blank" rel="noopener noreferrer" aria-label={s.label} className="opacity-80 hover:opacity-100 transition-opacity">
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h5 className="font-['Inter:Semi_Bold',sans-serif] font-semibold text-white text-[1rem] mb-6">Explore</h5>
            <ul className="font-['Lato:Regular',sans-serif] text-[#8399b9] text-[1.1rem] space-y-5">
              {[
                { label: "Home",                to: `${basePath}/home` },
                { label: "Solutions",           to: `${basePath}/solutions` },
                { label: "Technology",          to: `${basePath}/technology` },
                { label: "Investor Relations",  to: `${basePath}/company` },
              ].map(({ label, to }) => (
                <li key={label}>
                  <NavLink
                    to={to}
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    className="hover:text-white transition-colors"
                  >
                    {label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h5 className="font-['Inter:Semi_Bold',sans-serif] font-semibold text-white text-[1rem] mb-6">Resources</h5>
            <ul className="font-['Lato:Regular',sans-serif] text-[#8399b9] text-[1.1rem] space-y-5">
              {[
                { label: "Privacy Policy",                              to: "/privacy-policy" },
                { label: "Website Terms of Use",                        to: "/terms-of-use" },
                { label: "Parking Lot Management Terms of Service",     to: "/terms-of-service" },
              ].map(({ label, to }) => (
                <li key={label}>
                  <NavLink
                    to={to}
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    className="hover:text-white transition-colors"
                  >
                    {label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-[#2c3a4e] mt-10 pt-6 flex flex-col md:flex-row justify-between gap-2">
          <p className="font-['Lato:Regular',sans-serif] text-[#8399b9] text-[1.1rem] leading-[1.3]">
            © 2026 GeoParking Technologies, Inc. All rights reserved.
          </p>
          <p className="font-['Lato:Regular',sans-serif] text-[#8399b9] text-[1.1rem] leading-[1.3]">
            Driving smarter mobility — one parking space at a time.
          </p>
        </div>
      </div>
    </footer>
  );
}

// ─── Scroll to top ────────────────────────────────────────────────────────────
export function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll to top"
      className={`fixed bottom-8 right-8 z-50 size-14 rounded-full bg-[#0a66c2] shadow-lg flex items-center justify-center transition-all duration-300 hover:bg-[#0856a8] ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}
    >
      <svg className="w-7 h-7 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 19V5M5 12l7-7 7 7" />
      </svg>
    </button>
  );
}
